import { useTranslation } from 'react-i18next';
import { cn } from '@anytag/shared-utils';
import { DropdownOption } from '@anytag/shared-types';
import { Button, ButtonProps } from './button';
import { ButtonDropdown, ButtonDropdownProps } from './button-dropdown';

export type DownloadButtonProps<T extends DropdownOption = DropdownOption> = ButtonProps &
  Partial<Pick<ButtonDropdownProps<T>, 'options' | 'onSelectOption' | 'id'>>;

export const DownloadButton = <T extends DropdownOption>({
  title,
  options,
  className,
  onSelectOption,
  ...restProps
}: DownloadButtonProps<T>) => {
  const { t } = useTranslation();

  const defaultProps: ButtonProps = {
    variant: 'solid',
    title: title ?? t<string>('Button.Download'),
    prefixIcon: { icon: 'download', size: '14px' },
    ...restProps
  };

  return options && onSelectOption ? (
    <ButtonDropdown
      {...defaultProps}
      options={options}
      onSelectOption={onSelectOption}
      className={cn({ 'min-w-33': !!title }, className)}
    />
  ) : (
    <Button className={cn({ 'min-w-33': !!title }, className)} {...defaultProps} />
  );
};
